import TableDailyAssignedQR from './table-daily-assigned-qr.container';

export default TableDailyAssignedQR;
